<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Discount/Loading Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.discLdg }}</td>
            <td class="text-xs-left">{{ props.item.discLdgDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['travelRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Discount/Loading
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="discLdgDialog" width="800px" lazy v-if="checkAccess(['travelRatingReview'])" persistent >
        <discldg-dialog :discLdgForm="discLdgForm" @close="doClose" :newDiscLdg="newDiscLdg"></discldg-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Discount Loading? ({{deleteDiscLdg}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import DiscldgDialog from './DiscldgDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Discount/Loading Code', align: 'left', value: 'discLdg' },
        { text: 'Description', align: 'left', value: 'discLdgDesc' }
      ],
      discLdgForm: {
        discLdg: undefined,
        discLdgDesc: undefined
      },
      discLdgDialog: undefined,
      newDiscLdg: undefined,
      loading: false,
      promptRemove: false,
      selectedDiscLdg: undefined,
      deleteDiscLdg: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.travel.menu.getDiscLdgs
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((DiscLdg) => {
              const convertDiscLdg = {
                discLdg: DiscLdg.discLdg,
                discLdgDesc: DiscLdg.discLdgDesc
              }
              this.items.push(convertDiscLdg)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(DiscLdg) {
      const apiURI = this.$store.state.travel.menu.getDiscLdg
      const expand = {
        discLdg: DiscLdg.item.discLdg
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.discLdgForm.discLdg = data.discLdg.discLdg
          this.discLdgForm.discLdgDesc = data.discLdg.discLdgDesc
        }
        this.discLdgDialog = true
      }
    },
    doClose() {
      this.discLdgDialog = false
      this.newDiscLdg = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.discLdgDialog = true
      this.newDiscLdg = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedDiscLdg = data
        this.deleteDiscLdg = data.discLdg + ' - ' + data.discLdgDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.travel.menu.deleteDiscLdg
      if (apiURI) {
        this.loading = true
        const expand = {
          discLdg: this.selectedDiscLdg.discLdg
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['travelRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    DiscldgDialog: DiscldgDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
